import React from "react";
import useRegistrationFormsListService from "./service";
import TicketList from "apps/registration/components/ticket";
import TicketListHeader from "apps/registration/components/ticket/ticketHeader";
import SponsorAdBranding from "../../../../shared/components/sponsorAdBranding";
import { AdOrientation } from "../../../../shared/components/sponsorAdBranding/type";
import RegistrationFooter from "apps/registration/components/registrationFooter";
import classNames from "classnames";
import { isInIframe } from "shared/utils/iframe";
import InventorySubType from "../../../../shared/enums/InventorySubType";

export default function Home() {
  const { formsList, description, logo, title, sponsorAdList, isListingForSponsorOrg } =
    useRegistrationFormsListService();

  return (
    <React.Fragment>
      <div className={classNames("ticketsWrapper", { ticketsIframe: isInIframe })}>
        <TicketListHeader title={title} content={description} image={logo} />
        <TicketList ticketList={formsList} showSingleBuyButtonAtOnce={isListingForSponsorOrg} />
        {sponsorAdList && (
          <section className="container text-center">
            <SponsorAdBranding
              uuid={"ticketList"}
              displayHeader={false}
              adList={sponsorAdList}
              className={"regTicketsSponsor"}
              orientation={AdOrientation.HORIZONTAL}
              inventorySubType={InventorySubType.REGISTRATION}
            />
          </section>
        )}
      </div>
      <RegistrationFooter />
    </React.Fragment>
  );
}
